import React from 'react';
import { VehicleTypes } from '@hero/schema';
import { useVehicleOptions } from '@hero/hooks-shared';

export interface VehicleNameProps {
  vehicle: VehicleTypes;
  className?: string;
}

/**
 * VehicleName component - displays vehicle type with proper translation
 * Uses i18n key: vehicleTypes.{vehicle}
 * Falls back to raw vehicle type if translation not found
 */
export const VehicleName: React.FC<VehicleNameProps> = ({ vehicle, className = '' }) => {
  const { getVehicleDisplayName } = useVehicleOptions();
  return <span className={className}>{getVehicleDisplayName(vehicle)}</span>;
};
